import React, { useEffect, useState } from 'react';
import { Container, Box, Card, CardContent, Typography, TextField, Button, Alert, CircularProgress, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useParams, useNavigate } from 'react-router-dom';
import { verifyToken, resetPassword } from "../../Model/Login";


const VerifyTokenPage = () => {
  var { token } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [email, setEmail] = useState('');
  const [userId, setUserId] = useState('');
  // ✅ Validate token format (optional UX check)
  const isTokenFormatValid = (token) => {
    return token && token.length >= 30; // or use regex if needed
  };

  useEffect(() => {
    const validateToken = async () => {
      if (!isTokenFormatValid(token)) {
        setError('Invalid or missing token.');
        setIsLoading(false);
        // Opsyonal: I-redirect din dito kung gusto mo
        // setTimeout(() => navigate('/login'), 3000); 
        return;
      }
  
      try {
        const res = await verifyToken(token);
        console.log('Token check:', res);
  
        if (res.success) {
          setEmail(res.email);
          setUserId(res.userId);
          setTokenValid(true);
        } else {
          setError(res.msg || 'Invalid or expired token.');
          setTokenValid(false);
          
          // ✅ REDIRECT TO LOGIN: Kapag expire o invalid ang token
          setTimeout(() => {
            navigate('/login'); // Siguraduhin na '/login' ang tamang path mo
          }, 2000); // May 2 seconds delay para mabasa muna ang error alert
        }
      } catch (err) {
        console.error('Token validation failed:', err);
        setError('Server error or invalid token.');
        setTokenValid(false);
        
        // ✅ REDIRECT TO LOGIN: Kapag nag-error ang server
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } finally {
        setIsLoading(false);
      }
    };
  
    validateToken();
  }, [token, navigate]); // Idinagdag ang navigate sa dependency array
  // useEffect(() => {
  //       setError('Invalid or missing token.');
  //       setIsLoading(false);
  //     }
  
  //     try {
  //       console.log('Token check:', res);
  
  //         setEmail(res.email);
  //         setUserId(res.userId);
  //         setTokenValid(true);
  //       } else {
  //         setError(res.msg || 'Invalid or expired token.');
  //         setTokenValid(false);
  //       }
  //     } catch (err) {
  //       console.error('Token validation failed:', err);
  //       setError('Server error or invalid token.');
  //       setTokenValid(false);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };
  
  //   validateToken();
  // }, [token]);

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
  
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
  
    try {
      const payload = {
        email: email,      // Replace this dynamically if needed
        userId: userId,                     // Replace this dynamically if needed
        token: token,
        newpassword: password,
        confirmPassword: password
      };
   
      const res = await resetPassword(payload); // Pass the payload to the function
  
      if (res.success === true) {
        console.log('Password reset successful:', res);
        navigate('/reset-success');
      } else {
        setError(res.msg || 'Password reset failed.');
      }
  
    } catch (err) {
      console.error(err);
      setError('There was an error updating your password.');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box mt={10} display="flex" justifyContent="center">
        <Card sx={{ width: '100%', boxShadow: 3 }}>
          <CardContent>
            {isLoading ? (
              <Box display="flex" justifyContent="center" my={5}>
                <CircularProgress />
              </Box>
            ) : tokenValid ? (
              <>
                <Typography variant="h5" fontWeight="bold" textAlign="center" gutterBottom>
                  Reset Your Password
                </Typography>
                <Typography variant="body2" textAlign="center" color="text.secondary" mb={3}>
                  Enter a new password for your account.
                </Typography>

                {error && (
                  <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                  </Alert>
                )}

                <form onSubmit={handleSubmit}>
                  <TextField
                    label="New Password"
                    type={showPassword ? 'text' : 'password'}
                    fullWidth
                    margin="normal"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <TextField
                    label="Confirm Password"
                    type={showConfirm ? 'text' : 'password'}
                    fullWidth
                    margin="normal"
                    required
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowConfirm(!showConfirm)} edge="end">
                            {showConfirm ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    fullWidth
                    size="large"
                    sx={{
                      mt: 3,
                      height: 48,
                      borderRadius: 2,
                      fontWeight: 600,
                      textTransform: "none",
                      color: "#fff",
                      background: "linear-gradient(90deg, #495057 0%, #212529 100%)",
                      boxShadow: "0px 3px 6px rgba(0,0,0,0.2)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: "#343a40",
                        boxShadow: "0px 4px 12px rgba(0,0,0,0.3)",
                        transform: "translateY(-1px)",
                      },
                    }}
                  >
                    Update Password
                  </Button>
                </form>
              </>
            ) : (
              <Alert severity="error">No valid token was found in the URL.</Alert>
            )}
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default VerifyTokenPage;